module.exports = __webpack_public_path__ + "images/nv3.png";